import React, { useState } from "react";

export default function YouTubeGallery() {
  // Replace these with your actual YouTube video IDs
  const videos = [
    {
      id: "QFB0ZRen8Nc",
      title: "Latest Srilatha Rakesh Reddy Podcast Interview",
      featured: true,
    },
    // { id: "jNQXAC9IVRw", title: "Building Better Habits" },
    // { id: "L_jWHffIx5E", title: "Goal Setting Masterclass" },
    // { id: "9bZkp7q19f0", title: "Overcome Procrastination" },
    // { id: "kJQP7kiw5Fk", title: "Morning Routine Tips" },
    // { id: "tgbNymZ7vqY", title: "Mindfulness & Meditation" },
  ];

  const [selectedVideo, setSelectedVideo] = useState(videos[0]);

  return (
    <section className="py-12 px-4 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Watch & Learn
          </h2>
          <p className="text-gray-600 text-sm md:text-base">
            Explore our collection of life-changing videos
          </p>
        </div>

        {/* Main Featured Video */}
        <div className="mb-6">
          <div className="relative aspect-video bg-black rounded-2xl overflow-hidden shadow-xl">
            <iframe
              src={`https://www.youtube.com/embed/${selectedVideo.id}?autoplay=1&mute=1&rel=0`}
              title={selectedVideo.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="absolute inset-0 w-full h-full"
            ></iframe>
          </div>
          <div className="mt-4 px-2">
            <h3 className="text-lg md:text-xl font-semibold text-gray-900">
              {selectedVideo.title}
            </h3>
          </div>
        </div>

        {/* Video Thumbnails - Horizontal Scroll */}
        <div className="relative">
          <h3 className="text-lg font-semibold text-gray-900 mb-4 px-2">
            More Videos
          </h3>

          {/* Horizontal scrollable container */}
          <div className="overflow-x-auto pb-4 -mx-4 px-4 scrollbar-hide">
            <div className="flex gap-4 min-w-min">
              {videos.map((video) => (
                <div
                  key={video.id}
                  onClick={() => setSelectedVideo(video)}
                  className={`flex-shrink-0 w-48 md:w-56 cursor-pointer transition-all duration-300 ${
                    selectedVideo.id === video.id
                      ? "scale-105"
                      : "scale-100 opacity-80 hover:opacity-100"
                  }`}
                >
                  <div
                    className={`rounded-xl overflow-hidden shadow-lg ${
                      selectedVideo.id === video.id
                        ? "ring-4 ring-purple-500"
                        : ""
                    }`}
                  >
                    {/* Thumbnail */}
                    <div className="relative aspect-video bg-gray-900">
                      <img
                        src={`https://img.youtube.com/vi/${video.id}/mqdefault.jpg`}
                        alt={video.title}
                        className="w-full h-full object-cover"
                      />

                      {/* Play button overlay */}
                      <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-20 hover:bg-opacity-40 transition-all">
                        <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center shadow-lg transform hover:scale-110 transition-transform">
                          <svg
                            className="w-5 h-5 text-white ml-1"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M8 5v14l11-7z" />
                          </svg>
                        </div>
                      </div>

                      {/* Featured badge */}
                      {video.featured && (
                        <div className="absolute top-2 left-2 bg-purple-600 text-white text-xs font-semibold px-2 py-1 rounded-full">
                          Featured
                        </div>
                      )}
                    </div>

                    {/* Title */}
                    <div className="bg-white p-3">
                      <p className="text-sm font-medium text-gray-900 line-clamp-2">
                        {video.title}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Scroll indicator */}
          <div className="flex justify-center gap-2 mt-4">
            <div className="text-xs text-gray-400 flex items-center gap-1">
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 5l7 7-7 7M5 5l7 7-7 7"
                />
              </svg>
              Swipe to see more
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </section>
  );
}
